// @flow
import { styled } from 'goober';
import { useEffect } from 'preact/hooks';
import Button from 'preact-material-components/Button';
import 'preact-material-components/Button/style.css';
import whatsappLogo from '../../assets/salesApp/WhatsappSvgLogo.svg';
import successTick from '../../assets/salesApp/success-tick.gif';
import { useSalesAppTracker } from './tracker';

const OnSuccessSharedNtbLinkMsg = ({
  btnTxt,
  handleBtnClickForSuccessScreen,
  userName,
}) => {
  const SuccessMsgContainer = styled('div')`
    padding: 22px 10px 24px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .SucessMsgTxt {
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.2px;
      color: #636363;
      padding: 12px 0px;
    }
    #extraPadding {
      padding-left: 20px;
      padding-right: 20px;
    }
    .successGif {
      width: 96px;
      height: 96px;
    }
  `;
  const BtnContainerSection = styled('div')`
    #btnSection {
      width: 318px;
      height: 50px;
      margin: 0 auto;
      background-color: var(--primaryCTAColor);
      border-radius: 8px;
      border-color: transparent;
      font-style: normal;
      font-weight: 600;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.1px;
      color: #ffffff;
      text-transform: capitalize;
      text-align: center;
    }
    .btnContainer {
      margin: 26px 0px 0px;
      display: flex;
      justify-content: center;
    }
    .whatsAppSection {
      display: flex;
      img {
        padding-right: 11px;
      }
    }
  `;
  const pageKey = 'sa_pv_ntb_application_share_success';
  const salesAppTracker = useSalesAppTracker(pageKey);
  useEffect(() => {
    salesAppTracker.trackPageView('sa_pv_ntb_application_share_success');
  }, []);
  return (
    <SuccessMsgContainer>
      <img src={successTick} alt='success-gif' className='successGif' />
      <div className='SucessMsgTxt' id='extraPadding'>
        Successfully shared application link for availing new credit line
      </div>
      <div className='SucessMsgTxt' id='extraPadding'>
        Please ask {userName} to check their SMS and e-mail
      </div>
      <div className='SucessMsgTxt'>
        You can as well share the application link to your customer through
        WhatsApp.
      </div>
      <BtnContainerSection>
        <div className='btnContainer'>
          <Button
            id='btnSection'
            onClick={() => {
              salesAppTracker.trackClick(
                'sa_click_ntb_application_share_whatsapp',
                undefined,
              );
              handleBtnClickForSuccessScreen();
            }}>
            <span className='whatsAppSection'>
              <img src={whatsappLogo} alt='whatsAppIcon' />{' '}
              <p className='sendText'>{btnTxt}</p>
            </span>
          </Button>
        </div>
      </BtnContainerSection>
    </SuccessMsgContainer>
  );
};
export default OnSuccessSharedNtbLinkMsg;



// WEBPACK FOOTER //
// ./components/salesApp/OnSuccessSharedNtbLinkMsg.js